import React from "react";
import { Add as AddIcon, VisibilityOutlined as VisibilityOutlinedIcon } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppBadge } from "Components/AppBadge";
import { Button } from "Components/Form";
import { Color } from "Components/Form/Button";
import { ListContactsCards } from "./ListContactsCards";
import { ListContactsTable } from "./ListContactsTable";
import { Contact } from "Models/contact";
import { Timezone } from "Models/timezone";

export interface ContactSectionProps {
  contacts?: Contact[];
  viewOnly?: boolean;
  timezones?: Timezone[];
  onChange?: (contacts: Contact[]) => void;
  onViewContacts?: () => void;
  onClickAddContact?: () => void;
  onClickEditContact?: (contact?: Contact) => void;
  fieldHasError?: (field: string, params?: { useRegex: boolean }) => boolean;
  getErrorByField?: (field: string, params?: { useRegex: boolean }) => string | undefined;
}

export const ContactSection = (props: ContactSectionProps) => {
  const { t: translate } = useTranslation();

  const {
    contacts = [],
    timezones = [],
    viewOnly,
    onChange,
    onViewContacts,
    onClickAddContact,
    onClickEditContact,
    fieldHasError,
    getErrorByField,
  } = props;

  return (
    <>
      <Grid item xs={12}>
        <span
          style={{
            fontFamily: "Manrope",
            fontSize: "18px",
            fontWeight: 700,
            color: "#465869",
            lineHeight: "18px",
          }}
        >
          {translate("contact")}
        </span>

        <AppBadge
          variant="light-gray"
          paddingLeft="12px"
          paddingRight="12px"
          paddingTop="4px"
          paddingBottom="4px"
          sx={{ fontSize: "12px", marginLeft: "10px" }}
        >
          {contacts?.length ?? 0}
        </AppBadge>

        {/* Mostrar erros de validação de contacts */}
        {fieldHasError?.("contacts") && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
            {getErrorByField?.("contacts")}
          </div>
        )}
        {fieldHasError?.("contacts.primary") && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
            {getErrorByField?.("contacts.primary")}
          </div>
        )}
        {fieldHasError?.("^contacts\\[\\d+\\]\\..+", { useRegex: true }) && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
            {getErrorByField?.("^contacts\\[\\d+\\]\\..+", { useRegex: true })}
          </div>
        )}
      </Grid>

      <Grid container item xs={12} gap="16px">
        {contacts?.length === 1 ? (
          <ListContactsCards
            viewOnly={viewOnly}
            contacts={contacts}
            onChange={onChange}
            timezones={timezones}
          />
        ) : (
          <ListContactsTable
            viewOnly={viewOnly}
            contacts={contacts}
            onChange={onChange}
            onClickEditContact={onClickEditContact}
            timezones={timezones}
          />
        )}

        <Grid item container direction="row" gap="16px">
          {!viewOnly && (
            <Grid item>
              <Button
                data-cy="add-contact-button"
                customColor={Color.GRAY_600}
                startIcon={<AddIcon htmlColor="#FFF" />}
                onClick={onClickAddContact}
              >
                {translate("addNewContact")}
              </Button>
            </Grid>
          )}

          <Grid item>
            <Button
              onClick={onViewContacts}
              data-cy="view-contacts-button"
              customColor={Color.GRAY_600_TEXT}
              startIcon={<VisibilityOutlinedIcon htmlColor="#475467" />}
            >
              {translate("viewAllContacts")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
